import { useEffect } from 'react';
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
import { useStore } from 'store';
import { cleanListOfReviews, fetchReviews } from 'store/actions/reviews';
import styles from './style.module.scss';
import {carouselConfig} from './config'
import  Slider  from 'react-slick'
import ReviewItem from 'components/Cards/ReviewCard/index'
import { useWindowSize } from 'hooks';
//import {ReviewsCards} from 'pages/Reviews/ReviewsCards';

const HomeReviews = () => {
    const dispatch = useStore()[1]
    const [listOfReviews] = useStore(({ reviews }) => reviews.listOfReviews);
    const { results = { list: [] } } = listOfReviews;
    const [, {isMobile}] = useWindowSize()


    useEffect(() => {
        dispatch(fetchReviews({ withLoader: false }));

        return () => {
            dispatch(cleanListOfReviews());
        };
    }, []);

    return (
        <section className={`${styles.container} ${!isMobile &&  'container'}`}>
            <span className={styles.title}>Testimonios</span>
            <div className={styles['testimonials-container']}>
                {/*<ReviewsCards trueSlide />*/}
                <Slider {...carouselConfig}>
                    {
                        results.list.map(item => (
                            <ReviewItem
                                key = {item.id}
                                name = {item.name}
                                review={item.review}
                                date={item.date}
                                title={item.title}
                            />
                        ))
                    }
                </Slider>
            </div>
        </section>
    );
};

export default HomeReviews;
